import { useStrictLocalization } from "@faire/web/common/localization";
export var useLevelNodesSectionTitles = function useLevelNodesSectionTitles() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  return {
    selectIssueType: strictLocalize({
      id: "AtQqv9",
      defaultMessage: [{
        "type": 0,
        "value": "Selecteer een probleemtype"
      }]
    }),
    whatIssue: strictLocalize({
      id: "Psbx3c",
      defaultMessage: [{
        "type": 0,
        "value": "Wat is het probleem met deze bestelling?"
      }]
    }),
    whatIssueWithoutOrder: strictLocalize({
      id: "Kztnov",
      defaultMessage: [{
        "type": 0,
        "value": "Wat is het probleem?"
      }]
    }),
    chooseCategory: strictLocalize({
      id: "H4hJvF",
      defaultMessage: [{
        "type": 0,
        "value": "Kies een categorie"
      }]
    }),
    chooseType: strictLocalize({
      id: "04OZ+R",
      defaultMessage: [{
        "type": 0,
        "value": "Kies een type"
      }]
    }),
    chooseSubType: strictLocalize({
      id: "sOpfzU",
      defaultMessage: [{
        "type": 0,
        "value": "Kies een subtype"
      }]
    })
  };
};